import axios from "axios";
import { createContext, useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import LiveChat from "../components/LiveChat/LiveChat";
import DotLoading from "../components/Loading/DotLoading";
import baseUrl from "../utilities/baseUrl";
import pages from "../utilities/pages";

export const SharedDataContext = createContext();

function FetchSharedData() {
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  const [sharedData, setSharedData] = useState({
    user: null,
    pages: [],
  });

  const getSharedData = () => {
    if (isLoading && sharedData.pages.length !== 0) {
      return;
    }

    if (sharedData.pages.find(item => item.pathname === pathname)) {
      return;
    }

    if (
      pages.find(item => item.pathname === pathname) ||
      sharedData.pages.length === 0
    ) {
      setIsLoading(true);

      axios
        .get(baseUrl + "/user/v1/sharedData", {
          params: {
            pathname,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then(res => {
          setSharedData(cur => {
            cur.pages.push({ ...res.data.data.page, pathname });

            return {
              user: res.data.data.user,
              pages: cur.pages,
            };
          });

          setIsLoading(false);
        });
    }
  };

  useMemo(() => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    getSharedData();
  }, [pathname]);

  if (isLoading) {
    return <DotLoading />;
  }

  return (
    <SharedDataContext.Provider value={{ sharedData, setSharedData }}>
      <LiveChat />
      <Outlet />
    </SharedDataContext.Provider>
  );
}
export default FetchSharedData;
